<div class="d-flex flex-column">
    <button (click)="openModal()" class="btn btn-default" [disabled]="isLoading">

        {{'assignments.participants.registrationDetails.download' | transloco}}
        <span *ngIf="isLoading">
            <i class="fa-solid fa-download fa-bounce"></i>
        </span>
    </button>
</div>